module.exports = __webpack_public_path__ + "img/keybase-brands-grey.f18f3a14.svg";